import Hosts from '../../../Hosts';


const object_type = 'estancia/aula/event'

const api_crud_base = Hosts.SIMCore_API
const api_crud_route = `${Hosts.SIMCore_API}/${object_type}`
const api_list_route = (companycode) => `${Hosts.SIMCore_API}/${object_type}/${companycode}`

const base_endpoint = '/estancia_aula'

const endpoints = {
    base: base_endpoint,
    regist: `${base_endpoint}_regist`,
    list: `${base_endpoint}_list`,
    schedule: `${base_endpoint}_schedule`,
    //view: `${base_endpoint}_view`,
    view: `${base_endpoint}`,
}

const data_interface = {
    id: '',
    info: {
        companycode: '',
        name: '',
        category: 'Ski',       // 
        level: '',          // Iniciação | Intermédio | Avançado
        observation: '',
        description: '',
        detail: {   
            start:  '',
            end:    '',
            location: {id: '', name: ''},
            nivel: '',              // Iniciação | Intermédio | Avançado
            calendarId: '1',        // 
            category: "time",
            state: "free",          // free | busy
            raw: { class: 'public' },
            dueDateClass: '',
            isAllDay: false,
            isReadOnly: true,
        },
        instrutor: {
            id: '',
            name: '',
        },
        inscritos: [
            {
                name: '',
                age: '',
                identification_type: '',
                identification_number: '',
                codigo_compra: ''
            }
        ],
        media: {
            id: '',
            link: '',
        },  
        order: 0,
        status: true,
        language: []
    }
}

export {
    endpoints,
    object_type,
    api_crud_base,
    api_crud_route,
    data_interface,
    api_list_route,
}